



















import {defineComponent, PropType} from "vue";
import {ListItem} from "./models/ListItem";

export default defineComponent({
    name: "ListChronologicalOrder",
    props: {
        items: {
            type: Array as PropType<ListItem[]>,
            required: true
        },
        noBorderBottom: {
            type: Boolean,
            default: false
        }
    }
})

